/**
 * @enum
 * @readonly
 */
export const ThemeType = Object.freeze({
  GENERIC: 'generic',
  CUSTOM: 'custom',
});

export const DEFAULT_THEME_TYPE = ThemeType.GENERIC;
